import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { getTypography } from '@/src/materialui/typography/typography.theme';

export const flowDayCalendar: Components<Theme>['MuiDayCalendar'] = {
  styleOverrides: {
    // DateCalendar header week days (e.g. M, T, W)
    weekDayLabel: ({ theme }) => ({
      color: theme.palette.text.primary,
      [theme.breakpoints.up('xs')]: {
        ...getTypography('body', theme.direction === 'rtl', 'medium'),
        fontWeight: '400',
      },
      // update proportions to match figma
      margin: '4px 3px',
      width: '40px',
      height: '40px',
    }),
    slideTransition: {
      // increased from 240px to fit content without scroll
      minHeight: '294px',
    },
  },
};
